import styled from 'styled-components';
import { Paper, Typography } from "@mui/material";

export const ListHeaderContainer: any = styled(Paper)<{
    $darkMode?: boolean;
}>`
    display: flex;
    justify-content: space-between;
    // padding: 20px 20px 10px 20px;
    padding: 20px;
    align-items: center;
    border-bottom: 1px solid;
    box-shadow: none !important;
    border-radius: 5px 5px 0px 0px !important;
`;

export const StyledListHeaderContainer: any = styled.div<{
    $darkMode?: boolean;
}>`
    display: grid;
    grid-template-column: 1fr;
`;

export const StyledHeader: any = styled(Typography)<{
    $darkMode?: boolean;
}>`
    font-size: 1.2rem !important;
    font-weight: 600 !important;
    text-align: left !important;
`;

export const FilterAndButtonsContainer: any = styled.div<{
    $darkMode?: boolean;
}>`
    display: flex;
    justify-content: space-between;
    align-items: center;

    .headerBtnsContainer {
        margin: 0px 0px 0px 30px;
        display: grid;
        grid-template-columns: auto auto auto;
        gap: 10px;

    }
`;